/* ============================================================
   OpticalH / GafasCanarias — Global Cart Guard (v2)
   ------------------------------------------------------------
   Prevents adding products that REQUIRE a configurator
   (contact lenses, prescription glasses) to cart from ANY
   surface without first opening the product page.

   DESIGN: fail-open. The guard only blocks when it has a
   POSITIVE, cached confirmation that the product needs the
   configurator. Unknown products pass through untouched, so
   the theme's native cart flow is never broken for normal
   products.
   ============================================================ */
(function () {
  'use strict';

  var REQUIRED_TAGS = [
    'lentillas',
    'lentillas-torica',
    'lentillas-multifocal',
    'configurador-prescripcion'
  ];

  var REQUIRED_PROPS = {
    'lentillas':            ['Esfera', 'Potencia', 'Esférica'],
    'lentillas-torica':     ['Esfera', 'Potencia', 'Esférica', 'Cilindro', 'Eje'],
    'lentillas-multifocal': ['Esfera', 'Potencia', 'Esférica', 'Adición', 'Adicion'],
    'configurador-prescripcion': ['Esfera', 'Potencia', 'Esférica']
  };

  // Normaliza tildes y mayúsculas para que "POTENCIA ESFÉRICA" haga match con "Esfera"/"Potencia"
  function norm(s) {
    return String(s == null ? '' : s).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  }

  var cache = {};         // handle -> { tags: [], url: '', needs: tag|null }
  var variantToHandle = {}; // variantId -> handle (populated from DOM and from .js fetches)

  function firstMatchTag(tags) {
    if (!tags) return null;
    for (var i = 0; i < REQUIRED_TAGS.length; i++) {
      if (tags.indexOf(REQUIRED_TAGS[i]) !== -1) return REQUIRED_TAGS[i];
    }
    return null;
  }

  function getCached(handle) {
    return handle ? cache[handle] : null;
  }

  function fetchProductInfo(handle) {
    if (!handle) return Promise.resolve(null);
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return null;
        var info = {
          tags: p.tags || [],
          url: p.url || ('/products/' + handle),
          needs: firstMatchTag(p.tags || [])
        };
        cache[handle] = info;
        (p.variants || []).forEach(function (v) { variantToHandle[String(v.id)] = handle; });
        return info;
      })
      .catch(function () { return null; });
  }

  /* ---------- handle extraction ---------- */
  function handleFromElement(el) {
    if (!el) return null;
    if (el.dataset && el.dataset.productHandle) return el.dataset.productHandle;
    var href = (el.getAttribute && el.getAttribute('href')) || '';
    var m = href.match(/\/products\/([^\/?#]+)/);
    if (m) return m[1];
    return null;
  }

  function handleFromForm(form) {
    // 1) explicit attribute
    var h = form.dataset.productHandle;
    if (h) return h;
    // 2) sibling link
    var link = form.querySelector('a[href*="/products/"]');
    if (link) {
      var m = link.getAttribute('href').match(/\/products\/([^\/?#]+)/);
      if (m) return m[1];
    }
    // 3) ancestor link/card
    var anc = form.closest('[data-product-handle], a[href*="/products/"], article, .product-card, .card, li');
    while (anc) {
      var hh = handleFromElement(anc);
      if (hh) return hh;
      var al = anc.querySelector && anc.querySelector('a[href*="/products/"]');
      if (al) {
        var mm = al.getAttribute('href').match(/\/products\/([^\/?#]+)/);
        if (mm) return mm[1];
      }
      anc = anc.parentElement;
    }
    // 4) on product page — use URL
    var um = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    if (um) return um[1];
    return null;
  }

  function onProductPage(handle) {
    var path = window.location.pathname;
    if (handle && path.indexOf('/products/' + handle) !== -1) return true;
    return false;
  }

  function showToast(msg, url) {
    var t = document.createElement('div');
    t.style.cssText = 'position:fixed;bottom:24px;left:50%;transform:translateX(-50%);z-index:99999;background:#111;color:#fff;padding:14px 22px;border-radius:10px;font:14px/1.4 -apple-system,BlinkMacSystemFont,system-ui,sans-serif;box-shadow:0 6px 24px rgba(0,0,0,.2);max-width:90vw;text-align:center';
    t.innerHTML = msg + (url ? ' <a href="' + url + '" style="color:#8ab4ff;text-decoration:underline;margin-left:6px">Configurar →</a>' : '');
    document.body.appendChild(t);
    setTimeout(function () { t.style.transition = 'opacity .3s'; t.style.opacity = '0'; }, 4500);
    setTimeout(function () { t.parentNode && t.parentNode.removeChild(t); }, 4900);
  }

  function doBlock(info) {
    showToast('Este producto requiere configurar tu graduación.', info.url);
    setTimeout(function () { window.location.href = info.url; }, 350);
  }

  /* ---------- 1) Form submit — only block on CACHED positive ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;
    var handle = handleFromForm(form);
    if (!handle) return;                   // unknown → let through
    if (onProductPage(handle)) return;     // PDP handles its own modal
    var info = getCached(handle);
    if (info && info.needs) {              // CACHED positive → block
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      doBlock(info);
      return;
    }
    // Not cached yet → fire-and-forget warm-up for next click, DO NOT block now
    fetchProductInfo(handle);
  }, true);

  /* ---------- 2) Click guard on cards / quick-add ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button[name="add"], button[type="submit"][form*="product-form"], [data-add-to-cart], [data-quick-add], .product-form__submit, .oh-btn-cart, a[href*="/cart/add"]');
    if (!btn) return;
    // Determine handle from the button's context
    var form = btn.form || btn.closest('form[action*="/cart/add"]');
    var handle = form ? handleFromForm(form) : null;
    if (!handle) {
      var card = btn.closest('[data-product-handle], article, .product-card, .card, li');
      if (card) {
        handle = handleFromElement(card);
        if (!handle) {
          var a = card.querySelector && card.querySelector('a[href*="/products/"]');
          if (a) {
            var m = a.getAttribute('href').match(/\/products\/([^\/?#]+)/);
            if (m) handle = m[1];
          }
        }
      }
    }
    if (!handle) return;
    if (onProductPage(handle)) return;
    var info = getCached(handle);
    if (info && info.needs) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      doBlock(info);
      return;
    }
    fetchProductInfo(handle); // warm-up for next interaction
  }, true);

  /* ---------- 3) Fetch monkey-patch — fail-open ---------- */
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      if (url && /\/cart\/add(?:\.js)?(?:\?|$)/.test(url)) {
        var body = (init && init.body) || (typeof input === 'object' && input && input.body);
        var id = null;
        if (body instanceof FormData) id = body.get('id');
        else if (typeof body === 'string') {
          try {
            var parsed = JSON.parse(body);
            id = parsed.id || (parsed.items && parsed.items[0] && parsed.items[0].id);
          } catch (e) {
            try { id = new URLSearchParams(body).get('id'); } catch (_) {}
          }
        }
        var handle = id ? variantToHandle[String(id)] : null;
        if (!handle) {
          // Fallback: current product page URL
          var um = window.location.pathname.match(/\/products\/([^\/?#]+)/);
          if (um) handle = um[1];
        }
        if (handle && !onProductPage(handle)) {
          var info = getCached(handle);
          if (info && info.needs) {
            doBlock(info);
            return Promise.resolve(new Response(
              JSON.stringify({ status: 422, description: 'configurator-required' }),
              { status: 422, headers: { 'Content-Type': 'application/json' } }
            ));
          }
        }
      }
    } catch (_) {}
    return origFetch.apply(this, arguments);
  };

  /* ---------- 4) Pre-warm cache from page content ---------- */
  function prewarm() {
    var handles = new Set();
    document.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      var m = a.getAttribute('href').match(/\/products\/([^\/?#]+)/);
      if (m) handles.add(m[1]);
    });
    document.querySelectorAll('[data-product-handle]').forEach(function (el) {
      handles.add(el.dataset.productHandle);
    });
    var um = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    if (um) handles.add(um[1]);
    // Limit to first 30 to avoid hammering, prioritize unique
    var arr = Array.from(handles).slice(0, 30);
    arr.forEach(fetchProductInfo);
  }

  /* ============================================================
     PRODUCT PAGE: hide dynamic checkout for configurator products
     ============================================================ */
  function hideDynamicCheckoutIfNeeded() {
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    var handle = m[1];
    fetchProductInfo(handle).then(function (info) {
      if (!info || !info.needs) return;
      var sel = [
        '.shopify-payment-button',
        '.shopify-payment-button__button',
        'shop-pay-button',
        '[data-shopify="payment-button"]',
        '.dynamic-checkout',
        '.additional-checkout-buttons'
      ].join(',');
      var hide = function () {
        document.querySelectorAll(sel).forEach(function (el) {
          el.style.display = 'none';
          el.setAttribute('aria-hidden', 'true');
          el.tabIndex = -1;
        });
      };
      hide();
      var mo = new MutationObserver(hide);
      mo.observe(document.body, { childList: true, subtree: true });
      document.addEventListener('click', function (e) {
        var t = e.target.closest(sel);
        if (t) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          showToast('Configura tu graduación antes de continuar.', info.url);
        }
      }, true);
    });
  }

  /* ============================================================
     CART VALIDATION — runs on cart page / cart drawer
     ============================================================ */
  function validateCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        return Promise.all(items.map(function (item) {
          return fetchProductInfo(item.handle).then(function (info) {
            if (!info || !info.needs) return null;
            var req = REQUIRED_PROPS[info.needs] || [];
            var props = item.properties || {};
            var hasAny = false;
            for (var k in props) {
              if (!props.hasOwnProperty(k)) continue;
              var key = norm(k);
              for (var i = 0; i < req.length; i++) {
                if (key.indexOf(norm(req[i])) !== -1 && props[k]) { hasAny = true; break; }
              }
              if (hasAny) break;
            }
            return hasAny ? null : { title: item.product_title, url: info.url };
          });
        })).then(function (arr) { return arr.filter(Boolean); });
      })
      .catch(function () { return []; });
  }

  function applyCartGuardUI() {
    if (!/\/cart/.test(window.location.pathname) && !document.querySelector('cart-drawer, [data-cart-drawer]')) return;
    validateCart().then(function (missing) {
      var btns = document.querySelectorAll('[name="checkout"], button[name="checkout"], .cart__checkout, .shopify-payment-button button, [data-checkout]');
      var banner = document.getElementById('oh-cart-guard-banner');
      if (missing.length > 0) {
        btns.forEach(function (b) { b.disabled = true; b.style.opacity = '.5'; b.style.cursor = 'not-allowed'; b.setAttribute('aria-disabled', 'true'); });
        if (!banner) {
          banner = document.createElement('div');
          banner.id = 'oh-cart-guard-banner';
          banner.style.cssText = 'background:#fff3cd;border:1px solid #ffc107;color:#664d03;padding:12px 16px;border-radius:8px;margin:12px 0;font:14px/1.4 -apple-system,BlinkMacSystemFont,system-ui,sans-serif';
          var host = document.querySelector('main, .cart, cart-drawer, [data-cart-drawer]') || document.body;
          host.insertBefore(banner, host.firstChild);
        }
        banner.innerHTML = '<strong>Falta configurar tu graduación</strong> para finalizar la compra. Productos pendientes: ' +
          missing.map(function (m) { return '<a href="' + m.url + '" style="color:#664d03;text-decoration:underline">' + m.title + '</a>'; }).join(', ');
      } else {
        btns.forEach(function (b) { b.disabled = false; b.style.opacity = ''; b.style.cursor = ''; b.removeAttribute('aria-disabled'); });
        if (banner && banner.parentNode) banner.parentNode.removeChild(banner);
      }
    });
  }

  function init() {
    prewarm();
    hideDynamicCheckoutIfNeeded();
    applyCartGuardUI();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('cart:refresh', applyCartGuardUI);
  document.addEventListener('cart:updated', applyCartGuardUI);
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-cart-drawer-toggle], .header__cart')) {
      setTimeout(applyCartGuardUI, 600);
    }
  }, true);

})();
